module.exports = __webpack_public_path__ + "media/images/sandbox/folder_opt-691d8cb570bbd37aedd3f15bbee7ba7e.png";